const MetaEditor = {
  /**
   * Instantiate prompt
   *
   * @param {Object} obj
   * @return {Promise}
   */
  create(node) {
    this.api = node.dataset.api;

    $(node).on('change', 'input', ({ currentTarget }) => {
      this.save(currentTarget);
    });
  },

  save(target) {
    const $row = $(target).parents('.js-meta-row');
    const modelType = $row.data('model');
    const modelId = $row.data('id');

    const payload = {
      _method: 'PUT',
      title: $row.find('[name="title"]').val(),
      description: $row.find('[name="description"]').val(),
      modelType,
      modelId,
    };

    this.sendRequest(payload);
  },

  sendRequest(payload) {
    window.axios.post(this.api, payload)
      .then((res) => {
        if (res.data !== 'ok') {
          this.showMessage('error');

          return;
        }

        this.showMessage('success');
      })
      .catch(() => {
        this.showMessage('error');
      });
  },

  showMessage(type) {
    if (type === 'error') {
      window.toaster.show('Er ging iets mis bij het opslaan', 2500, 'danger');

      return;
    }

    window.toaster.show('Meta informatie opgeslagen', 2500);
  },
};

export default MetaEditor;
